import cookies from '@/utils/cookies';
import axios from 'axios';
import { INTERNAL_ERROR, UNDEFINED } from '../enums/errorEnums';

export const addAuthorizationHeader = (config) => {
  const requestConfig = { ...config };

  requestConfig.headers.Authorization = cookies.getItem('token');

  return requestConfig;
};

const api = axios.create({
  baseURL: process.env.VUE_APP_BASE_API,
  timeout: process.env.VUE_APP_REQUEST_TIMEOUT,
});

api.interceptors.request.use(addAuthorizationHeader);

api.interceptors.response.use(
  (response) => response,
  (error) => {
    const { response } = error;
    if (response) {
      const { status } = response;

      const canThrowAnError = status === UNDEFINED || status === INTERNAL_ERROR;

      if (canThrowAnError) {
        throw new Error(response.data.message);
      }
      return Promise.resolve(response);
    }
    throw new Error(error);
  },
);

export default api;
